import { LocalColorType } from "@/types/constants/colors";
import { query } from "./api";

export const GetAllColors = async (): Promise<LocalColorType[]> => {
    const result = await query(
        `query{
            allColor{
                red, 
                green,
                blue,
                name,
            }
        }`);
    return result.data.allColor;
};